import FastlinkService from './fastlink.service';

export function FastlinkProvider() {
  // Create a script tag with moment as the source
  // and call our onScriptLoad callback when it
  // has been loaded
  function createScript() {
    if (!document) { return; }
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://cdn.yodlee.com/fastlink/v3/initialize.js';

    // Attach the script tag to the document head
    var s = document.getElementsByTagName('head')[0];
    s.appendChild(script);
  }

  this.$get = ["$window", "$uibModal", "$errorReporter", function($window, $uibModal, $errorReporter) {
    createScript();

    return new FastlinkService($window, $uibModal, $errorReporter);
  }];
};

export default FastlinkProvider;
